import { useState, useMemo } from "react";
import { useTranslate } from "@refinedev/core";

import { usePaginatedTable, useQueryParams } from "@shared/hooks";
import { Notification } from "@modules/notifications/types";

export function useNotificationsList() {
  const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const translate = useTranslate();
  const { getQueryParams } = useQueryParams();

  const { rows, loading, refetch, ...tableProps } = usePaginatedTable<Notification>({
    resource: "v1/agreement_app_admin",
    filters: getQueryParams(),
    sorters: { ordering: "-id" },
  });

  const dataToExport = useMemo(() => (
    selectedRows.length > 0 ? rows.filter((row) => selectedRows.includes(row.id)) : rows
  ), [selectedRows, rows]);

  return {
    rows,
    loading,
    tableProps,
    selectedRows,
    dataToExport,
    refetch,
    setSelectedRows,
    translate,
  };
}
